import React from 'react';
import {
  BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip,
  Legend, ResponsiveContainer
} from 'recharts';
import { colors } from '../../brand-colors';

/**
 * End Game Chart - Track progress toward exit strategy goals
 * Shows Actual vs Goal with Sales/Profit toggle
 */
function EndGameChart({ data, showProfit = false }) {
  if (!data || !data.chart_data || data.chart_data.length === 0) {
    return (
      <div style={styles.placeholder}>
        <p>No exit strategy data available</p>
        <small>Set up your exit strategy in Profit Map</small>
      </div>
    );
  }

  const goalKey = showProfit ? 'goal_profit' : 'goal_revenue';
  const actualKey = showProfit ? 'actual_profit' : 'actual_revenue';
  const label = showProfit ? 'Profit' : 'Revenue';

  return (
    <ResponsiveContainer width="100%" height={250}>
      <BarChart
        data={data.chart_data}
        margin={{ top: 20, right: 30, left: 20, bottom: 5 }}
      >
        <CartesianGrid strokeDasharray="3 3" stroke="#e0e0e0" />
        <XAxis
          dataKey="month"
          tick={{ fill: colors.grey, fontSize: 12 }}
        />
        <YAxis
          tick={{ fill: colors.grey, fontSize: 12 }}
          tickFormatter={(value) => `$${(value / 1000).toFixed(0)}k`}
        />
        <Tooltip
          contentStyle={{
            backgroundColor: '#fff',
            border: '1px solid #e0e0e0',
            color: colors.greyDarkest
          }}
          formatter={(value) => [`$${value.toLocaleString()}`, '']}
        />
        <Legend />
        <Bar
          dataKey={goalKey}
          name={`Goal ${label}`}
          fill={colors.tealMid}
        />
        <Bar
          dataKey={actualKey}
          name={`Actual ${label}`}
          fill={colors.tealDark}
        />
      </BarChart>
    </ResponsiveContainer>
  );
}

const styles = {
  placeholder: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    height: 250,
    color: colors.greyMid,
    textAlign: 'center'
  }
};

export default EndGameChart;
